import { PrintProviderClass } from "@/typings/printify/printProvider";

export const printProviderFake: PrintProviderClass = { id: 1, title: '' };